
import {useReducer} from 'react';

import {Txn} from './types';

type State = Txn[];

type Action =
  | { type: 'SET', txns: Txn[] }
  | { type: 'CHAIN', txns: Txn[] };

const reducer = (state: State, action: Action): State => {
	switch (action.type) {
	case 'SET':
		return [...action.txns];
	case 'CHAIN':
		return [
			...state,
			...action.txns.slice(1),
		];
	}
};

export const useState = () => (
	useReducer(reducer, [])
);
